function getFirstLineText(variant, ageRange?, adventureCategory?, sitterFirstName?, sitterLastInitial?): string | null {
  if (variant === 'base') {
    return `Led by ${sitterFirstName} ${sitterLastInitial}.`;
  }
  if (variant === 'active') {
    return `${adventureCategory} • Ages ${ageRange}`;
  }
  if (variant === 'small') {
    return `Ages ${ageRange}`;
  }
  return null;
}

function getSecondLineText(ageRangeText, adventureCategoryName): string | null {
  return `Ages ${ageRangeText} • ${adventureCategoryName}`;
}

function getAdventureDetailsUrl(adventureLocation, adventureId): string | null {
  if (adventureLocation && adventureLocation.cityname && adventureLocation.stateabbr && adventureId) {
    const url = `/adventures/details/${adventureLocation.stateabbr}/${adventureLocation.cityname}/${adventureId}`;
    return url.toLowerCase();
  }
  return null;
}

export default {
  getFirstLineText,
  getAdventureDetailsUrl,
  getSecondLineText,
};
